import { post, postFormData } from './http';
import { dataLayerAddToCart } from './Gtm.service';
import { metaServiceAddToCartEvent } from './Meta.service';
import { pinterestServiceAddToCartEvent } from './Pinterest.service';
import { CartState } from '../Reducers/Cart.reducer';
import { OrderRow } from '../Types/OrderRow';
import { adformServiceAddToCartEvent } from './Adform.service';
import MeasuredWallpaperCuttingsData from '../Types/MeasuredWallpaperCuttingsData';
import { CustomWallpaperFile } from '../Components/MeasuredWallpaperCutout/CustomWallpaper/CustomWallpaperDropzone';

export const add = async ({
  articleNumber,
  quantity = 1,
}: {
  articleNumber: string;
  quantity?: number;
}) => {
  if (
    !quantity ||
    isNaN(quantity) ||
    parseFloat(quantity?.toString()) <= 0
  ) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/cart/add', {
    articleNumber,
    quantity: parseFloat(quantity?.toString()),
  });

  var result: CartState = await response.json();

  try {
    addToDataLayer(
      [{ articleNumber, quantity }],
      result.orderRows,
      result.currency
    );
  } catch (err) {
    console.log(err);
  }

  return result;
};

interface AddMeasuredWallpaperToCartProps {
  articleNumber: string;
  quantity?: number;
  wallWidth: number;
  wallHeight: number;
  wallpaperMaterial: string;
  cuttingsData: MeasuredWallpaperCuttingsData;
  customWallpaperFile?: CustomWallpaperFile;
}

export const addMeasuredWallpaperToCart = async ({
  articleNumber,
  quantity = 1,
  wallWidth,
  wallHeight,
  wallpaperMaterial,
  cuttingsData,
  customWallpaperFile,
}: AddMeasuredWallpaperToCartProps) => {
  if (
    !quantity ||
    isNaN(quantity) ||
    parseFloat(quantity?.toString()) <= 0
  ) {
    throw 'Invalid quantity';
  }

  const formData = new FormData();
  formData.set('articleNumber', articleNumber);
  formData.set('quantity', quantity.toString());
  formData.set('wallWidth', wallWidth.toString());
  formData.set('wallHeight', wallHeight.toString());
  formData.set('wallpaperMaterial', wallpaperMaterial);

  for (let key of Object.keys(cuttingsData)) {
    const value = cuttingsData[key];
    formData.set(key, value);
  }

  if (customWallpaperFile) {
    formData.set('customWallpaperFile', customWallpaperFile.file);
    formData.set(
      'customWallpaperWidth',
      customWallpaperFile.width.toString()
    );
    formData.set(
      'customWallpaperHeight',
      customWallpaperFile.height.toString()
    );
  }

  const response = await postFormData('/api/cart/add/measured', formData);
  const result: CartState = await response.json();

  try {
    addToDataLayer(
      [{ articleNumber: articleNumber?.toString() ?? '', quantity: 1 }],
      result.orderRows,
      result.currency
    );
  } catch (err) {
    console.log(err);
  }

  return result;
};

export const reorder = async (orderId) => {
  const response = await post('/api/cart/reorder', { orderId });
  return response.json();
};

const addToDataLayer = (
  products: any[],
  orderRows: OrderRow[],
  currency: string
) => {
  let responseProducts: OrderRow[] = [];
  orderRows.map((row) => {
    for (const i in products) {
      if (Object.hasOwnProperty.call(products, i)) {
        if (products[i].articleNumber === row.articleNumber) {
          const index = responseProducts.findIndex(
            (e) => e.articleNumber === row.articleNumber
          );
          if (index === -1) {
            if (row.gtmEcommerceItem) {
              row.gtmEcommerceItem.quantity = products[i].quantity;
              row.gtmEcommerceItem.index = responseProducts.length;
            }
            responseProducts.push(row);
            metaServiceAddToCartEvent(row);
            pinterestServiceAddToCartEvent({
              quantity: row.quantity,
              price:
                (row.priceInfo?.campaignPrice ?? row.priceInfo?.price)
                  ?.price ?? 0,
              currency,
            });
            adformServiceAddToCartEvent(row);
          }
        }
      }
    }
  });

  const gtmEcommerceItems: any = responseProducts.map(
    (p) => p.gtmEcommerceItem
  );
  if (gtmEcommerceItems) {
    dataLayerAddToCart(gtmEcommerceItems);
  }
};